import { RESOURCE } from "../../../../routes/const";

export default () => [
  {
    action: "manage",
    subject: RESOURCE.finance.rightholderStatementManager,
  },
];
